import React from 'react';

export default function IoCard({
  name,
  meta,
}: {
  name: string;
  meta?: { type?: string; description?: string };
}) {
  const type = meta?.type?.trim();
  const desc = meta?.description?.trim();
  const fullTitle = [name, desc, (type || 'string')]
    .filter((x) => typeof x === 'string' && x.trim())
    .join('\n');

  return (
    <div className="pac-glass rounded-md px-1.5 py-1" title={fullTitle}>
      <div className="text-[10px] text-neutral-200 truncate">{name}</div>
      {desc ? (
        <div className="text-[10px] text-neutral-500 leading-snug truncate">{desc}</div>
      ) : null}
      <div className="text-[10px] text-neutral-400 mt-0.5">{type || 'string'}</div>
    </div>
  );
}
